import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { ValidationStatus } from "./helperComponents";
import { ValidationSummaryProps } from "../types/confirmationTypes";
import styles from "../Confirmation.module.css";

export const ValidationSummary = ({isGeneralComplete, isSourceFileComplete, canSave, showOverrideWarning}: ValidationSummaryProps) => {
  return (
    <div className={styles.validationSummary}>
      <h3>
        Form Status
      </h3>
      <div className={styles.validationList}>
        <ValidationStatus isValid={isGeneralComplete} label="General Information" />
        <ValidationStatus isValid={isSourceFileComplete} label="Source File" />
      </div>
      
      {!canSave && !showOverrideWarning && (
        <div className={styles.warningMessage}>
          <FontAwesomeIcon icon={faExclamationTriangle} className={styles.warningIcon} />
          <span>Please complete all required sections before saving.</span>
        </div>
      )}
    </div>
  );
};